/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CustomersIdPaymenthistoryGet200ResponseInnerDiscount model module.
 * @module model/CustomersIdPaymenthistoryGet200ResponseInnerDiscount
 * @version 1.0.0
 */
class CustomersIdPaymenthistoryGet200ResponseInnerDiscount {
    /**
     * Constructs a new <code>CustomersIdPaymenthistoryGet200ResponseInnerDiscount</code>.
     * Discount applied to this payment, if any
     * @alias module:model/CustomersIdPaymenthistoryGet200ResponseInnerDiscount
     */
    constructor() { 
        
        CustomersIdPaymenthistoryGet200ResponseInnerDiscount.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CustomersIdPaymenthistoryGet200ResponseInnerDiscount</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CustomersIdPaymenthistoryGet200ResponseInnerDiscount} obj Optional instance to populate.
     * @return {module:model/CustomersIdPaymenthistoryGet200ResponseInnerDiscount} The populated <code>CustomersIdPaymenthistoryGet200ResponseInnerDiscount</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CustomersIdPaymenthistoryGet200ResponseInnerDiscount();

            if (data.hasOwnProperty('coupon')) {
                obj['coupon'] = ApiClient.convertToType(data['coupon'], 'String');
            }
            if (data.hasOwnProperty('promo_code')) {
                obj['promo_code'] = ApiClient.convertToType(data['promo_code'], 'String');
            }
            if (data.hasOwnProperty('amount_off')) {
                obj['amount_off'] = ApiClient.convertToType(data['amount_off'], 'Number');
            }
            if (data.hasOwnProperty('percent_off')) {
                obj['percent_off'] = ApiClient.convertToType(data['percent_off'], 'Number');
            }
            if (data.hasOwnProperty('discount_amount')) {
                obj['discount_amount'] = ApiClient.convertToType(data['discount_amount'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CustomersIdPaymenthistoryGet200ResponseInnerDiscount</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CustomersIdPaymenthistoryGet200ResponseInnerDiscount</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['coupon'] && !(typeof data['coupon'] === 'string' || data['coupon'] instanceof String)) {
            throw new Error("Expected the field `coupon` to be a primitive type in the JSON string but got " + data['coupon']);
        }
        // ensure the json data is a string
        if (data['promo_code'] && !(typeof data['promo_code'] === 'string' || data['promo_code'] instanceof String)) {
            throw new Error("Expected the field `promo_code` to be a primitive type in the JSON string but got " + data['promo_code']);
        }

        return true;
    }


}



/**
 * Coupon name or ID
 * @member {String} coupon
 */
CustomersIdPaymenthistoryGet200ResponseInnerDiscount.prototype['coupon'] = undefined;

/**
 * Promotion code used
 * @member {String} promo_code
 */
CustomersIdPaymenthistoryGet200ResponseInnerDiscount.prototype['promo_code'] = undefined;

/**
 * Fixed amount discounted in smallest currency unit
 * @member {Number} amount_off
 */
CustomersIdPaymenthistoryGet200ResponseInnerDiscount.prototype['amount_off'] = undefined;

/**
 * Percentage discounted
 * @member {Number} percent_off
 */
CustomersIdPaymenthistoryGet200ResponseInnerDiscount.prototype['percent_off'] = undefined;

/**
 * Actual amount discounted in smallest currency unit (cents)
 * @member {Number} discount_amount
 */
CustomersIdPaymenthistoryGet200ResponseInnerDiscount.prototype['discount_amount'] = undefined;






export default CustomersIdPaymenthistoryGet200ResponseInnerDiscount;

